import { render } from "./App.vue?vue&type=template&id=549b8975"
const script = {}

import "./App.vue?vue&type=style&index=0&id=549b8975&lang=scss"

import exportComponent from "/var/www/showroom/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__